import { render, staticRenderFns } from "./CodeVerification.vue?vue&type=template&id=61a357bc&scoped=true"
import script from "./CodeVerification.vue?vue&type=script&lang=js"
export * from "./CodeVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a357bc",
  null
  
)

export default component.exports